import { useEffect, useState } from 'react'
import { open } from '@/store/modalsSlice'
import { OFFERS_PREMIUM_MODAL } from '@/common/constants/modals'
import { useDispatch, useSelector } from 'react-redux'
import { getCookie, setCookie } from 'cookies-next'
import { userAmplitudeAnalytics } from '@/common/services/userAmplitudeAnalytics'
import { ANALYTIC_OFFER } from '@/common/constants/analytics'
import { SUBSCRIPTION_DEMO } from '@/common/constants/payments'

const SESSION_LIMITS = {
  SESSION_1: 3,
  SESSION_2: 7,
  SESSION_3: 14,
}

const MODAL_CONTENT = {
  [SESSION_LIMITS.SESSION_1]: {
    title: 'session-title-1',
    description: 'session-description-1',
    buttonText: 'session-button-1',
  },
  [SESSION_LIMITS.SESSION_2]: {
    title: 'session-title-2',
    description: 'session-description-2',
    buttonText: 'session-button-2',
  },
  [SESSION_LIMITS.SESSION_3]: {
    title: 'session-title-3',
    description: 'session-description-3',
    buttonText: 'session-button-3',
  },
}

const useSessionOfferModal = () => {
  const [isVisibleOffersPremiumModal, setIsVisibleOffersPremiumModal] =
    useState(false)
  const [modalContent, setModalContent] = useState({})
  const dispatch = useDispatch()
  const { subscription } = useSelector((state) => state.user)

  useEffect(() => {
    if (!subscription) return
    if (subscription?.name !== SUBSCRIPTION_DEMO) return
    let sessionsCount = Number(getCookie('sessionsCount')) || 0
    sessionsCount += 1

    setCookie('sessionsCount', sessionsCount.toString())

    if (MODAL_CONTENT[sessionsCount]) {
      setModalContent(MODAL_CONTENT[sessionsCount])
      setIsVisibleOffersPremiumModal(true)
      userAmplitudeAnalytics.trackEvent(
        `${ANALYTIC_OFFER}_collapse_banner_shown`,
        {
          trigger: `${sessionsCount}s`,
        }
      )
      dispatch(open(OFFERS_PREMIUM_MODAL))
    }
  }, [subscription])

  return {
    isVisibleOffersPremiumModal,
    modalContent,
  }
}

export default useSessionOfferModal
